/*jshint browserify: true */
'use strict';

module.exports = renderImageInCentre;

/**
 * Draws an image in the centre of a bounding box, scaled to fill the box while maintaining its aspect ratio.
 *
 * @param {HTMLImageElement} image
 * @param {CanvasRenderingContext2D} canvasContext
 * @param {Number} xPos - The left edge of the bounding box
 * @param {Number} yPos - The top edge of the bounding box
 * @param {Number} width - The width of the bounding box
 * @param {Number} height - The height of the bounding box
 * @param {Number} imageWidth
 * @param {Number} imageHeight
 */
function renderImageInCentre(image, canvasContext, xPos, yPos, width, height, imageWidth, imageHeight) {
    var zoomWidth = width / imageWidth;
    var zoomHeight = height / imageHeight;
    var zoom = zoomWidth > zoomHeight ? zoomHeight : zoomWidth;

    var scaledWidth = imageWidth * zoom;
    var scaledHeight = imageHeight * zoom;

    var xPosOffset = 0;
    if (scaledWidth < width) {
        xPosOffset = (width - scaledWidth) / 2;
    }

    var yPosOffset = 0;
    if (scaledHeight < height) {
        yPosOffset = (height - scaledHeight) / 2;
    }

    //console.log(xPosOffset + ', ' + yPosOffset + ', ' + scaledWidth + 'x' + scaledHeight);

    canvasContext.drawImage(image, xPos + xPosOffset, yPos + yPosOffset, scaledWidth, scaledHeight);
}